import React from 'react';
import styled from 'styled-components';
import { respondTo } from 'styles/helper';
import { MemberEntity } from 'model/api/GetMvpds';
import Loader from 'components/common/Loader';
import ProviderButton from '../ProviderButton';

export type Props = {
  topProviders: MemberEntity[] | undefined;
  handleMVPDSelect: (adobePassId: string) => void;
};

const TopProviders = ({ topProviders = [], handleMVPDSelect }: Props): JSX.Element => {
  if (!topProviders.length) return <Loader abCenter />;
  let className;
  if (topProviders.length === 1) {
    className = 'isSingle';
  }
  return (
    <Grid role="presentation" data-testid="custom-element" className={className}>
      {topProviders?.map((item) => {
        const { logos, provider, id, adobePassId } = item;
        return (
          <ProviderButton
            handleMVPDSelect={() => handleMVPDSelect(adobePassId)}
            key={id}
            provider={provider}
            url={logos?.[1]?.url || ''}
          />
        );
      })}
    </Grid>
  );
};

export default TopProviders;

const Grid = styled.section`
  position: relative;
  display: grid;
  width: 100%;
  margin-bottom: 0;
  gap: 10px;
  grid-template: repeat(4, minMax(0, 80px)) / repeat(2, 1fr);
  ${respondTo.bp_768`
    grid-template: 100px / 160px;
    width: 670px;
    grid-template: repeat(2, 100px) / repeat(4, 1fr);
  `}
  &.returning-provider-logo {
    align-content: center;
    justify-content: center;
    margin-bottom: 40px;
    grid-template: 80px / 150px;
    ${respondTo.bp_768`
      grid-template: 100px / 160px;
    `}
  }
  &.isSingle {
    grid-template: 1fr / 1fr;
    width: 160px;
  }
`;
